// Note: !important
// Use a string with caps and spaces for the event name
// Use snake_case for all property names
// Note: This file, freeTrial.js, is an exception to our usual analytics initialization process.
// Typically, the front-end analytics library handles initialization when a user is authenticated.
// However, since this file is public and not behind a login, we can't rely on the library to initialize Amplitude.
// Therefore, we explicitly call analytics.init() to ensure Amplitude is ready before tracking events or identifying users.
// This approach is acceptable here because all users accessing the free trial page will be centralized.
// Importantly, this is a unique situation and should not be used as a pattern for other analytics calls.
// For more details, please refer to the front-end analytics documentation.
import { analytics } from 'swipeclock-frontend';

const { trackEvent } = analytics;

const EVENT = 'Free Trial';

const trackEmailVerification = () => {
  analytics.init();
  trackEvent(EVENT, 'Email Verified');
};

const trackError = (message) => {
  analytics.init();
  trackEvent(EVENT, 'Error', { message });
};

const trackRegistration = (data) => {
  analytics.init();
  const { companyName, numberOfEmployees, phone } = data ?? {};
  const props = {
    company: companyName,
    employees: numberOfEmployees,
    areaCode: phone.substring(0, 3),
  };
  trackEvent(EVENT, 'Registration', props);
};

const trackSiteCreation = () => {
  analytics.init();
  trackEvent(EVENT, 'Site Created');
};

const trackSiteReady = (site) => {
  analytics.init();
  trackEvent(EVENT, 'Site Ready', { site });
};

const trackWFHClicked = (site) => {
  analytics.init();
  trackEvent(EVENT, 'WFH Clicked', { site });
  // WFHClicked makes the user redirect to the site
  // We call flush to ensure the event is sent before the redirect
  analytics.flush();
};

const trackUser = (values) => {
  analytics.init();
  analytics.user.setEmail(values?.email);
  analytics.user.setCampaignId(values?.campaignId);
  analytics.user.setCompanyName(values?.companyName);
  analytics.user.identify({ forceIdentify: true });
};

export default {
  event: EVENT,
  trackEmailVerification,
  trackError,
  trackRegistration,
  trackSiteCreation,
  trackSiteReady,
  trackWFHClicked,
  trackUser,
};
